module.exports = __webpack_public_path__ + "static/media/mz.1044789c.svg";